import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar, Footer, ScrollProgressBar } from './index';
import { AnimatedAstronaut, FluidCursor } from '../effects';
import BirthdayPill from './BirthdayPill';
// import hadiImage from '../../assets/hadi/bicharta_koiren.jpg';

const Main = () => {
    const location = useLocation();
    const isAdminRoute = location.pathname.startsWith('/admin') || location.pathname.startsWith('/dashboard');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <div className={`flex flex-col min-h-screen text-designer-dark relative overflow-hidden ${isAdminRoute ? 'bg-[#F4F6F9]' : 'bg-white'}`}>
            {!isAdminRoute && <ScrollProgressBar />}
            {!isAdminRoute && (
                <>
                    <FluidCursor />
                    <AnimatedAstronaut type="01" className="global-astronaut-1" />
                    <AnimatedAstronaut type="02" className="global-astronaut-2" />
                    <AnimatedAstronaut type="01" className="global-astronaut-3" />
                    <AnimatedAstronaut type="02" className="global-astronaut-4" />
                </>
            )}

            {!isAdminRoute && <Navbar />}
            <main className="flex-grow">
                {isAdminRoute ? (
                    <Outlet />
                ) : (
                    <div className="container-responsive py-8 md:py-12">
                        <Outlet />
                    </div>
                )}
            </main>
            {!isAdminRoute && <Footer />}
            {!isAdminRoute && <BirthdayPill />}
        </div>
    );
};

export default Main;
